import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type InventoryChangePreparedEntityTableName = 'inventory_changes';

export type PreparedInventoryChangeData = {
    record: Model;
    table: InventoryChangePreparedEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: InventoryChangePreparedEntityTableName,
    operation: ValidationOperation,
): PreparedInventoryChangeData => ({
    record,
    table,
    operation,
});

export const addPreparedDataBatch = async (
    preparedData: PreparedInventoryChangeData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
